import React from 'react';
import { FormLabel, FormValue } from '../Form/FormLabel';
import { Row } from 'reactstrap'
import { Button } from 'reactstrap'
import { Route, Switch, useHistory } from 'react-router-dom';
import Editor from '../Models/Editor';
import entities from '../../utils/entities';
const ClientDetail = ({ route,client, clientDepartment }) => {
    const history = useHistory();

    const setItemId = (id) => id ? history.push(route + "/client/" + id + '/Detail') : history.push(route);
    return (client ? <React.Fragment>
        <FormLabel>{route ? <Button size="sm" onClick={() => setItemId(client.id)}>Client ({client.status})</Button> : 'Client'}</FormLabel>
        <FormValue>{client.companyName} - ({client.clientType})</FormValue>
        {clientDepartment ? null : <Row> <FormValue> {client.firstName + ' ' + client.lastName + ' ' + client.email}</FormValue></Row>}
        <Switch>
            <Route path={route + '/client/:clientId/:clientAction/:list/:activeKey'} render={({ match }) => <Editor route={route + '/client'} entity={entities.client} itemId={match.params.clientId} editorClosed={() => setItemId()} />} />

            <Route path={route + '/client/:clientId/:clientAction/:list'} render={({ match }) => <Editor route={route + '/client'} entity={entities.client} itemId={match.params.clientId} editorClosed={() => setItemId()} />} />

            <Route path={route + '/client/:clientId/:clientAction'} render={({ match }) => <Editor route={route + '/client'} entity={entities.client} itemId={match.params.clientId} editorClosed={() => setItemId()} />} />


        </Switch>
    </React.Fragment> : null)
};

export default ClientDetail;